import request from '@/utils/request'
import NProgress from 'nprogress' // progress bar

export function getPermission() {
  return request({
    url: '/sys/get/permission',
    method: 'get',
  })
}

export function login(data) {
  return request({
    url: '/sys/login',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/sys/logout',
    method: 'post'
  })
}

export function adminPage(params) {
  return request({
    url: '/sys/admin/page',
    method: 'get',
    params
  })
}

export function getSmsCode(params) {
  return request({
    url: '/sys/get/sms-code',
    method: 'get',
    params
  })
}

export function adminList(params) {
  return request({
    url: '/sys/admin/list',
    method: 'get',
    params
  })
}

export function adminGet(params) {
  return request({
    url: '/sys/admin/get',
    method: 'get',
    params
  })
}

export function adminVerify(data) {
  return request({
    url: '/sys/admin/verify',
    method: 'post',
    data
  })
}

export function adminChangeWorkStatus(data) {
  return request({
    url: '/sys/admin/change-work-status',
    method: 'post',
    type: "json",
    data
  })
}

export function adminChangeStatus(data) {
  return request({
    url: '/sys/admin/change-status',
    method: 'post',
    type: "json",
    data
  })
}

export function adminAdd(data) {
  return request({
    url: '/sys/admin/add',
    method: 'post',
    type: "json",
    data
  })
}

export function adminEdit(data) {
  return request({
    url: '/sys/admin/edit',
    method: 'post',
    type: "json",
    data
  })
}

export function adminUpdatePassword(data) {
  return request({
    url: '/sys/admin/update/password',
    method: 'post',
    data
  })
}

export function adminDel(data) {
  return request({
    url: '/sys/admin/del',
    method: 'post',
    data
  })
}


export function roleList(params) {
  return request({
    url: '/sys/role/list',
    method: 'get',
    params
  })
}

export function permissionList(params) {
  return request({
    url: '/sys/permission/list',
    method: 'get',
    params
  })
}

export function dictMap(params) {
  return request({
    url: '/sys/dict/map',
    method: 'get',
    params
  })
}

export function countryMap(params) {
  return request({
    url: '/sys/country/map',
    method: 'get',
    params
  })
}

export function countryList(params) {
  return request({
    url: '/sys/country/list',
    method: 'get',
    params
  })
}

export function getOptions(params) {
  return request({
    url: '/sys/get/options',
    method: 'get',
    params
  })
}

export function getLogs(params) {
  return request({
    url: '/sys/get/logs',
    method: 'get',
    params
  })
}

export function roleUpdate(data) {
  return request({
    url: '/sys/role/update',
    method: 'post',
    data
  })
}

export function adminListRoleKeyCodes(data) {
  return request({
    url: '/sys/admin/list/role_key_codes',
    method: 'post',
    type: "json",
    data
  })
}

export function roleDel(data) {
  return request({
    url: '/sys/role/del',
    method: 'post',
    data
  })
}

export function collectPage(params) {
  return request({
    url: '/sys/collect/page',
    method: 'get',
    params
  })
}

export function collectList(params) {
  return request({
    url: '/sys/collect/list',
    method: 'get',
    params
  })
}

export function collectMap(params) {
  return request({
    url: '/sys/collect/map',
    method: 'get',
    params
  })
}

export function collectAdd(data) {
  return request({
    url: '/sys/collect/add',
    method: 'post',
    type: "json",
    data
  })
}

export function collectEdit(data) {
  return request({
    url: '/sys/collect/edit',
    method: 'post',
    type: "json",
    data
  })
}

export function collectDel(data) {
  return request({
    url: '/sys/collect/del',
    method: 'post',
    data
  })
}

export function collectDataAdd(collectId, data) {
  return request({
    url: '/sys/collect/data/add?collectId=' + collectId,
    method: 'post',
    type: "json",
    data
  })
}

export function collectDataDel(params) {
  return request({
    url: '/sys/collect/data/del',
    method: 'post',
    params
  })
}

export function register(data) {
  return request({
    url: '/sys/register',
    method: 'post',
    data
  })
}

export function reset(data) {
  return request({
    url: '/sys/reset',
    method: 'post',
    data
  })
}

export function fileManagePage(params) {
  return request({
    url: '/sys/file-manage/page',
    method: 'get',
    params
  })
}


export function fileManageAdd(data) {
  return request({
    url: '/sys/file-manage/add',
    method: 'post',
    type: "json",
    data
  })
}

export function fileManageUpdate(data) {
  return request({
    url: '/sys/file-manage/update',
    method: 'post',
    type: "json",
    data
  })
}

export function fileManageDel(data) {
  return request({
    url: '/sys/file-manage/del',
    method: 'post',
    data
  })
}

export function tagPage(params) {
  return request({
    url: '/sys/tag/page',
    method: 'get',
    params
  })
}

export function tagList(params) {
  return request({
    url: '/sys/tag/list',
    method: 'get',
    params
  })
}

export function tagMap(params) {
  return request({
    url: '/sys/tag/map',
    method: 'get',
    params
  })
}

export function affiliateSummary(params) {
  return request({
    url: '/sys/affiliate/summary',
    method: 'get',
    params
  })
}

export function childAdminSummary(params) {
  return request({
    url: '/sys/child-admin/summary',
    method: 'get',
    params
  })
}

export function loginLog(params) {
  return request({
    url: '/sys/login-log',
    method: 'get',
    params
  })
}

export function supplierUploadSummary(params) {
  return request({
    url: '/sys/supplier/upload-summary',
    method: 'get',
    params
  })
}

export function tagAdd(data) {
  return request({
    url: '/sys/tag/add',
    method: 'post',
    type: "json",
    data
  })
}

export function tagUpdate(data) {
  return request({
    url: '/sys/tag/update',
    method: 'post',
    type: "json",
    data
  })
}

export function tagDel(data) {
  return request({
    url: '/sys/tag/del',
    method: 'post',
    data
  })
}

export function decryptPhone(data) {
  return request({
    url: '/sys/decrypt/phone',
    method: 'post',
    data
  })
}

export function getScreenConfig() {
  return request({
    url: '/sys/get/screen-config',
    method: 'get',
  })
}

export function updateScreenConfig(data) {
  return request({
    url: '/sys/update/screen-config',
    method: 'post',
    type: "json",
    data,
  })
}

export function upload(relateId, files) {
  if (!files || files.length == 0) {
    return;
  }
  let formData = new FormData();
  formData.append("relateId", relateId);
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    formData.append('files', file, file.name);
  }
  NProgress.start()
  return request({
    url: '/storage/upload',
    method: 'post',
    data: formData,
    headers: {
      "post": {'Content-Type': 'multipart/form-data'}
    }
  }).finally(() => {
    NProgress.done()
  })
}

export function buildOptions(options, data) {
  for (let i = 0; i < data.length; i++) {
    const d = data[i];
    const children = [];
    if (d.children && d.children.length > 0) {
      buildOptions(children, d.children);
    }
    const result = {
      id: d.key,
      title: d.value,
      level: d.level,
      value: d.key,
      label: d.value
    };
    if (children.length > 0) {
      result.children = children;
    }
    options.push(result);
  }
  return options;
}




// WEBPACK FOOTER //
// ./src/admin/api/sys.js